import { baseApi } from '@shared/api/baseApi';

export interface CelebrationSettingsDto {
  recurringEnabled: boolean;
  newUsersEnabled: boolean;
  intervalDays: 1 | 2;
}

export const celebrationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCelebration: builder.query<CelebrationSettingsDto, void>({
      query: () => '/celebration',
      providesTags: ['Celebration'],
    }),
  }),
});

export const { useGetCelebrationQuery } = celebrationApi;
